module.exports = __webpack_public_path__ + "img/piping_width.56c86041.png";